export const PLATFORM_NAV_ITEMS = Object.freeze([
  { path: '/conferencing/meetings/', label: 'Конференции', icon: 'video' },
  { path: '/library/', label: 'Библиотека', icon: 'library' },
  { path: '/digests/', label: 'Дайджест', icon: 'digest' },
  { path: '/shared/', label: 'Приглашения', icon: 'invite' },
  { path: '/conferencing/team-recordings/', label: 'Записи команды', icon: 'team' },
  { path: '/prompt-manager/', label: 'Промт-менеджер', icon: 'prompt' },
  { path: '/neo-ai/', label: 'NEO AI', icon: 'neo', feature: 'neo_ai_enabled' },
  { path: '/conferencing/external-recordings/', label: 'Внешние записи', icon: 'cloud', feature: 'external_recordings_enabled' },
  { path: '/admin/companies/', label: 'Компании', icon: 'company', admin: true },
  { path: '/admin/users/', label: 'Пользователи', icon: 'users', admin: true },
  { path: '/admin/team-access/', label: 'Командные доступы', icon: 'access', admin: true },
  { path: '/admin/calendar/', label: 'Календари', icon: 'calendar', admin: true },
  { path: '/admin/settings/', label: 'Настройки компании', icon: 'settings', admin: true },
  { path: '/admin/speakers/', label: 'Спикеры', icon: 'speakers', admin: true },
  { path: '/admin/errors/', label: 'Ошибки', icon: 'errors', admin: true },
  { path: '/admin/desktop-feedback/', label: 'Журнал тестирования', icon: 'errors', admin: true },
  { path: '/applications/', label: 'Приложения', icon: 'applications' },
  { path: '/support/', label: 'Поддержка', icon: 'support' },
]);

export const PLATFORM_RESOURCE_ROUTES = Object.freeze([
  { id: 'more', match: /^\/more\/?$/, title: 'Ещё' },
  { id: 'meetings', match: /^\/conferencing\/meetings\/?$/, title: 'Конференции', endpoint: '/api/meetings' },
  { id: 'meeting-create', match: /^\/conferencing\/meetings\/edit\/?$/, title: 'Запланировать встречу' },
  { id: 'meeting-recording', match: /^\/conferencing\/meetings\/(?:[^/]+\/)?recordings\/([^/]+)\/?$/, title: 'Запись встречи', endpoint: '/api/meeting-recordings/{id}' },
  { id: 'meeting-recording-edit', match: /^\/conferencing\/meetings\/(?:[^/]+\/)?recordings\/([^/]+)\/edit\/?$/, title: 'Редактирование записи', endpoint: '/api/meeting-recordings/{id}' },
  { id: 'meeting-edit', match: /^\/conferencing\/meetings\/([^/]+)\/edit\/?$/, title: 'Редактирование встречи', endpoint: '/api/meetings/{id}' },
  { id: 'meeting-detail', match: /^\/conferencing\/meetings\/([^/]+)\/?$/, title: 'Встреча', endpoint: '/api/meetings/{id}' },
  { id: 'library', match: /^\/library\/?$/, title: 'Библиотека', endpoint: '/api/library' },
  { id: 'digests', match: /^\/digests\/?$/, title: 'Дайджест', endpoint: '/api/digests' },
  { id: 'shared', match: /^\/shared\/?$/, title: 'Приглашения', endpoint: '/api/shared-meetings' },
  { id: 'team-recordings', match: /^\/conferencing\/team-recordings\/?$/, title: 'Команда', endpoint: '/api/team-recordings' },
  { id: 'team-recording-detail', match: /^\/conferencing\/team-recordings\/([^/]+)\/?$/, title: 'Запись команды', endpoint: '/api/team-recordings/{id}' },
  { id: 'prompts', match: /^\/prompt-manager\/?$/, title: 'Промт-менеджер', endpoint: '/api/prompts' },
  { id: 'neo', match: /^\/neo-ai\/?$/, title: 'NEO AI', endpoint: '/api/neo-ai/spaces' },
  { id: 'external-recordings', match: /^\/conferencing\/external-recordings\/?$/, title: 'Внешние записи', endpoint: '/api/external-recordings' },
  { id: 'external-recording-edit', match: /^\/conferencing\/external-recordings\/([^/]+)\/edit\/?$/, title: 'Редактирование внешней записи', endpoint: '/api/external-recordings/{id}' },
  { id: 'external-recording-detail', match: /^\/conferencing\/external-recordings\/([^/]+)\/?$/, title: 'Внешняя запись', endpoint: '/api/external-recordings/{id}' },
  { id: 'admin-companies', match: /^\/admin\/companies\/?$/, title: 'Компании', endpoint: '/api/admin/companies', admin: true },
  { id: 'admin-users', match: /^\/admin\/users\/?$/, title: 'Пользователи', endpoint: '/api/admin/users', admin: true },
  { id: 'admin-team-access', match: /^\/admin\/team-access\/?$/, title: 'Командные доступы', endpoint: '/api/admin/team-access', admin: true },
  { id: 'admin-calendar', match: /^\/admin\/calendar\/?$/, title: 'Календари', endpoint: '/api/admin/calendar-webhooks', admin: true },
  { id: 'admin-settings', match: /^\/admin\/settings\/?$/, title: 'Настройки компании', endpoint: '/api/admin/settings/join-consents', admin: true },
  { id: 'admin-speakers', match: /^\/admin\/speakers\/?$/, title: 'Спикеры', endpoint: '/api/admin/speaker-profiles', admin: true },
  { id: 'admin-errors', match: /^\/admin\/errors\/?$/, title: 'Ошибки', endpoint: '/api/admin/errors', admin: true },
  { id: 'admin-desktop-feedback', match: /^\/admin\/desktop-feedback\/?$/, title: 'Журнал тестирования', endpoint: '/api/admin/desktop-feedback', admin: true },
  { id: 'profile', match: /^\/profile\/?$/, title: 'Профиль', endpoint: '/api/profile' },
  { id: 'settings', match: /^\/settings\/?$/, title: 'Настройки', endpoint: '/api/settings' },
  { id: 'applications', match: /^\/applications\/?$/, title: 'Приложения' },
  { id: 'support', match: /^\/(?:support|contacts)\/?$/, title: 'Поддержка', endpoint: '/api/support' },
  { id: 'version', match: /^\/version-history\/?$/, title: 'История версий', endpoint: '/api/version-history' },
]);

export function resolvePlatformRoute(pathname) {
  const path = cleanPath(pathname);
  for (const route of PLATFORM_RESOURCE_ROUTES) {
    const match = route.match.exec(path);
    if (!match) continue;
    const id = decodeURIComponent(match[1] || '');
    return Object.freeze({
      ...route,
      path,
      resourceId: id,
      endpoint: route.endpoint ? route.endpoint.replace('{id}', encodeURIComponent(id)) : '',
    });
  }
  return Object.freeze({
    ...PLATFORM_RESOURCE_ROUTES[0],
    path,
    resourceId: '',
    endpoint: '/api/meetings',
  });
}

export function isPublicPlatformPath(pathname) {
  const path = cleanPath(pathname);
  return /^\/join\/[^/]+(?:\/[^/]+)?\/?$/.test(path)
    || /^\/shared\/[^/]+\/?$/.test(path);
}

export function publicPlatformEndpoint(pathname) {
  const path = cleanPath(pathname);
  const parts = path.split('/').filter(Boolean);
  if (parts[0] === 'shared' && parts[1]) return `/api/shared/${encodeURIComponent(parts[1])}`;
  if (parts[0] === 'join' && parts[1]) {
    const query = parts[2] ? `?moderator_code=${encodeURIComponent(parts[2])}` : '';
    return `/api/public/join/${encodeURIComponent(parts[1])}${query}`;
  }
  return '';
}

export function navigateAccount(path, historyLike = globalThis.history) {
  const target = canonicalPlatformPath(path);
  historyLike.pushState({}, '', target);
  globalThis.dispatchEvent?.(new PopStateEvent('popstate'));
  return target;
}

export function canonicalPlatformPath(value) {
  const raw = String(value || '/').trim() || '/';
  const target = raw.startsWith('/') ? raw : `/${raw}`;
  return target.replace(/^\/contacts\/?(?=([?#]|$))/, '/support/');
}

function cleanPath(value) {
  const path = String(value || '/').trim().split(/[?#]/, 1)[0] || '/';
  return path.startsWith('/') ? path : `/${path}`;
}
